import React from 'react';

import cn from 'classnames';

import { Skeleton } from '@shared/ui';

import cls from './FilterPaymentsSkeletons.module.css';

export const FilterPaymentsSkeletons = () => (
    <>
        <div className={cn(cls.FilterPaymentsSkeletonsFirstRow)}>
            <Skeleton height={28} border="2px" />
            <Skeleton height={28} border="2px" />
            <Skeleton height={28} border="2px" />
            <Skeleton height={28} border="2px" />
        </div>
        <div className={cn(cls.FilterPaymentsSkeletonsSecondRow)}>
            <Skeleton height={28} border="2px" />
            <Skeleton height={28} border="2px" />
            <Skeleton height={28} border="2px" />
            <Skeleton height={28} border="2px" />
            <Skeleton height={28} border="2px" />
        </div>
        <div className={cn(cls.FilterPaymentsSkeletonsThirdRow)}>
            <Skeleton height={20.516} border="2px" />
        </div>
    </>
);
